// LIGHTPAY-PG-PRODUCTION-READY-1 · 통합 주문 상세 · 상품·수량 단위 카드 부분취소 (기존 라이트페이 취소 경로 재사용).
import React, { useRef, useState } from 'react';
import { toast } from 'sonner';
import api from '@/lib/api';

const won = (n) => `${(Number(n) || 0).toLocaleString('ko-KR')}원`;
const newReq = () => `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;

export const PartialCancelPanel = ({ sellerOrderId, items, onDone }) => {
  const [open, setOpen] = useState(false);
  const [qty, setQty] = useState({});
  const [plan, setPlan] = useState(null);
  const [busy, setBusy] = useState(false);
  const reqId = useRef(newReq());
  const rows = (items || []).filter((it) => it.seller_order_item_id)
    .map((it) => ({ ...it, avail: Math.max(0, (it.quantity || 0) - (it.shipped_qty || 0)) }));
  const lines = Object.entries(qty).filter(([, q]) => q > 0).map(([id, q]) => ({ seller_order_item_id: id, quantity: q }));
  const setQ = (id, q, max) => { setPlan(null); setQty((p) => ({ ...p, [id]: Math.max(0, Math.min(max, q)) })); };

  const preview = async () => {
    setBusy(true);
    try { setPlan((await api.post('/payments/lightpay/partial-cancel/preview', { seller_order_id: sellerOrderId, lines })).data); }
    catch (e) { toast.error(e?.response?.data?.detail || '환불금액 계산 실패'); }
    finally { setBusy(false); }
  };
  const submit = async () => {
    if (!plan || !window.confirm(`${won(plan.amount)}을 카드 부분취소할까요? 라이트페이에 실제 취소가 요청되며 되돌릴 수 없습니다.`)) return;
    setBusy(true);
    try {
      await api.post('/payments/lightpay/partial-cancel', { seller_order_id: sellerOrderId, lines, request_id: reqId.current, reason: '판매자 부분취소' });
      toast.success('부분취소가 완료되었습니다.');
      reqId.current = newReq(); setQty({}); setPlan(null); setOpen(false); onDone?.();
    } catch (e) { toast.error(e?.response?.data?.detail || '부분취소 실패 · 주문은 변경되지 않았습니다.'); }
    finally { setBusy(false); }
  };

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} data-testid="uod-partial-cancel-open"
              className="mt-2 ml-1 px-3 py-1 rounded-full border border-black/20 dark:border-white/20 text-[11px] font-black hover:bg-black/5">부분취소</button>
    );
  }
  return (
    <div className="mt-3 p-3 rounded-lg border border-[#FF3B30]/30 bg-[#FF3B30]/[0.03] space-y-2" data-testid="uod-partial-cancel-panel">
      <p className="text-xs font-black">취소할 상품·수량 선택</p>
      {rows.map((it) => (
        <div key={it.seller_order_item_id} className="flex items-center gap-2 text-xs" data-testid={`pc-row-${it.seller_order_item_id}`}>
          <div className="flex-1 min-w-0">
            <p className="font-bold break-words">{it.name_snapshot}{Object.keys(it.option || {}).length ? ` · ${Object.values(it.option).join('/')}` : ''}</p>
            <p className="text-[10px] text-gray-500" data-testid={`pc-avail-${it.seller_order_item_id}`}>{won(it.unit_price)} · 주문 {it.quantity}개 · 가능 {it.avail}개</p>
          </div>
          <div className="inline-flex items-center border border-black/10 dark:border-white/10 rounded-full shrink-0">
            <button type="button" className="px-2 py-0.5" onClick={() => setQ(it.seller_order_item_id, (qty[it.seller_order_item_id] || 0) - 1, it.avail)}
                    data-testid={`pc-dec-${it.seller_order_item_id}`} aria-label="취소 수량 감소">-</button>
            <span className="px-1.5 font-bold" data-testid={`pc-qty-${it.seller_order_item_id}`}>{qty[it.seller_order_item_id] || 0}</span>
            <button type="button" className="px-2 py-0.5 disabled:opacity-30" disabled={(qty[it.seller_order_item_id] || 0) >= it.avail}
                    onClick={() => setQ(it.seller_order_item_id, (qty[it.seller_order_item_id] || 0) + 1, it.avail)}
                    data-testid={`pc-inc-${it.seller_order_item_id}`} aria-label="취소 수량 증가">+</button>
          </div>
        </div>
      ))}
      {plan && (
        <div className="text-xs rounded-md bg-white dark:bg-black/30 p-2 space-y-0.5" data-testid="pc-plan">
          <p>예상 환불금액 <b className="text-[#FF3B30]" data-testid="pc-plan-amount">{won(plan.amount)}</b>{plan.full ? ' · 전액취소로 처리' : ''}</p>
          <p className="text-gray-500" data-testid="pc-plan-remaining">남은 결제금액 {won(plan.remaining_after)}</p>
        </div>
      )}
      <div className="flex flex-wrap items-center gap-2 whitespace-nowrap">
        <button type="button" onClick={preview} disabled={busy || !lines.length} data-testid="pc-preview"
                className="px-3 py-1 rounded-full border text-[11px] font-black disabled:opacity-40">예상 환불금액 확인</button>
        <button type="button" onClick={submit} disabled={busy || !plan} data-testid="pc-submit"
                className="px-3 py-1 rounded-full bg-[#FF3B30] text-white text-[11px] font-black disabled:opacity-40">부분취소 실행</button>
        <button type="button" onClick={() => { setOpen(false); setQty({}); setPlan(null); }} className="ml-auto text-[11px] text-gray-500" data-testid="pc-close">닫기</button>
      </div>
    </div>
  );
};

export default PartialCancelPanel;
